var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSound = function SvgSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.633 15.605.309-.515-.143-.084h-.166zm0-7.195v.6H6.8l.144-.086zm6-3.598h.6a.6.6 0 0 0-.908-.515zm0 14.39-.308.515a.6.6 0 0 0 .908-.515zm-6-4.196-2.4-.001v1.2h2.4zm-2.4-.001a.6.6 0 0 1-.6-.6h-1.2c0 .996.805 1.8 1.8 1.8zm-.6-.6V9.61h-1.2v4.797h1.2zm0-4.795a.6.6 0 0 1 .6-.6v-1.2c-.995 0-1.8.804-1.8 1.8zm.6-.6h2.4v-1.2h-2.4zm2.71-.086 5.999-3.597-.617-1.03-6 3.598zm5.09-4.112v14.39h1.2V4.812zm.909 13.876-6-3.598-.617 1.03 6 3.597zM17.285 4.231a.75.75 0 0 1 1.06 0c4.296 4.296 4.296 11.26 0 15.556a.75.75 0 0 1-1.06-1.06 9.5 9.5 0 0 0 0-13.436.75.75 0 0 1 0-1.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.848 7.766a.749.749 0 0 0-1.28.53.75.75 0 0 0 .22.531 4.5 4.5 0 0 1 0 6.364.75.75 0 0 0 1.06 1.06 6 6 0 0 0 0-8.485"
  }))));
};
export default SvgSound;